import axios from 'axios';

// Function to get the token from cookies
const getCookie = (name) => {
  const cookie = document.cookie
    .split('; ')
    .find(row => row.startsWith(name + '='));
  return cookie ? cookie.split('=')[1] : null;
};
//https://rw56csvk-3000.euw.devtunnels.ms/api
//https://cashback-479780104538.europe-west2.run.app
// Create axios instance
const api = axios.create({
  baseURL: 'https://cashback-479780104538.europe-west2.run.app/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor
api.interceptors.request.use(
  (config) => {
    // Get the access token from cookies
    const authToken = getCookie('accessToken');
    // console.log("🚀 ~ authToken:", authToken)
    
    // If the access token exists, add it to the request headers
    if (authToken) {
      config.headers.Authorization = `Bearer ${authToken}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
